<div class="modal-overlay lao" (click)="closeModal()">
    <div class="modal-content " (click)="$event.stopPropagation()">
        <!-- <h2>{{ data.name }}</h2>  -->
        <img [src]="data.image" alt="{{ data.name }}" class="modal-image" />
        <hr>
        <p>{{ data.description }}</p>
        <a [href]="data.link" target="_blank" rel="noopener noreferrer">Page: {{ data.name }}</a>
        <hr>
        <button class="partner-dialog-button" (click)="closeModal()">Close</button>
    </div>
</div>